export default function camelCase(string = '') {
  const chunks = []
  let chunk = ''
  let isUppercased = false

  for (let index = 0, length = string.length; index !== length; index++) {
    const char = string[index]
    if (!/[a-zA-Z0-9]/.test(char)) {
      if (chunk.length !== 0) {
        isUppercased = false
        chunks.push(chunk)
        chunk = ''
      }
    } else if (/[0-9]/.test(char)) {
      isUppercased = false
      chunk += char
      chunks.push(chunk)
      chunk = ''
    } else if (/[A-Z]/.test(char)) {
      if (chunk.length === 0) {
        isUppercased = true
        chunk += char
      } else if (isUppercased) {
        chunk += char
      } else if (chunk.length !== 0) {
        isUppercased = false
        chunks.push(chunk)
        chunk = char
      }
    } else {
      isUppercased = false
      chunk += char
    }
  }

  if (chunk.length !== 0) {
    isUppercased = false
    chunks.push(chunk)
    chunk = ''
  }

  let result = ''
  for (const chunk of chunks) {
    const normalized = /[a-z]/.test(chunk) ? chunk : chunk.toLowerCase()
    if (result.length === 0) {
      result += normalized.slice(0, 1).toLowerCase() + normalized.slice(1)
    } else {
      result += normalized.slice(0, 1).toUpperCase() + normalized.slice(1)
    }
  }

  return result
}
